import {Proposal} from './proposal';

export interface VersionFieldChange {
  field: string;
  oldValue: any;
  newValue: any;
}

export class ProposalVersionHistoryEntry {
  proposal: Proposal = new Proposal();
  changes: VersionFieldChange[] = [];

  constructor(raw?: any) {
    if (raw == null) {
      return;
    }
    this.proposal = new Proposal(raw.proposal);
    this.changes = Array.isArray(raw.changes) ? raw.changes : [];
  }
}
